/**
 * Author: Romain Hapi Sr.
 * Version: 1.0
 * Date: 2026-06-25
 * Project: Prenim Digital
 * Copyright: Prenim UK
 */
/**
 * Contenu du site Tchad : traductions, projets, offres, temoignages.
 *
 * Le nom « mock » vient du prototype ; ces donnees ne sont plus provisoires,
 * elles sont le contenu servi en production. Projets et temoignages sont servis
 * tels quels ; seules les offres d'emploi sont d'abord demandees a l'API
 * (`/api/careers`), celles d'ici servant de repli — voir `pages/Careers.js`.
 */
// Mock data for Prenim Tchad website

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      about: 'À Propos',
      projects: 'Nos produits',
      careers: 'Carrières',
      contact: 'Contact'
    },
    hero: {
      title: 'Transformez Votre Entreprise avec',
      subtitle: 'Excellence Numérique',
      description: 'Solutions innovantes en transformation digitale, développement d\'applications et infrastructure IT pour les entreprises africaines et européennes',
      cta: 'Découvrir Nos Services',
      ctaSecondary: 'Nous Contacter'
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Des solutions complètes pour votre transformation digitale',
      digitalTransformation: {
        name: 'Transformation Digitale',
        description: 'Modernisez vos processus métier avec des stratégies digitales sur mesure'
      },
      consulting: {
        name: 'Conseil IT',
        description: 'Expertise stratégique pour optimiser votre infrastructure technologique'
      },
      integration: {
        name: 'Intégration de Systèmes',
        description: 'Solutions d\'intégration transparentes pour vos systèmes d\'entreprise'
      },
      development: {
        name: 'Développement Web & Desktop',
        description: 'Applications web et desktop performantes adaptées à vos besoins'
      },
      devops: {
        name: 'DevOps',
        description: 'Automatisation et optimisation de vos pipelines de déploiement'
      },
      networking: {
        name: 'Réseau & Infrastructure',
        description: 'Architecture réseau robuste et sécurisée pour votre entreprise'
      }
    },
    projects: {
      title: 'Nos produits',
      subtitle: 'Les logiciels conçus par Prenim et nos réalisations à travers l\'Afrique',
      viewDetails: 'Voir Détails'
    },
    testimonials: {
      title: 'Ce Que Disent Nos Clients',
      subtitle: 'La confiance de nos partenaires'
    },
    careers: {
      title: 'Rejoignez Notre Équipe',
      subtitle: 'Construisez votre carrière avec nous',
      apply: 'Postuler'
    },
    contact: {
      title: 'Contactez-Nous',
      subtitle: 'Discutons de votre projet',
      first_name: 'Prénom',
      last_name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      message: 'Message',
      send: 'Envoyer',
      uk: 'Bureau Royaume-Uni',
      chad: 'Bureau N\'Djamena'
    },
    footer: {
      company: 'Entreprise',
      services: 'Services',
      contact: 'Contact',
      rights: 'Tous droits réservés'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      projects: 'Our products',
      careers: 'Careers',
      contact: 'Contact'
    },
    hero: {
      title: 'Transform Your Business with',
      subtitle: 'Digital Excellence',
      description: 'Innovative solutions in digital transformation, application development and IT infrastructure for African and European businesses',
      cta: 'Discover Our Services',
      ctaSecondary: 'Contact Us'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Complete solutions for your digital transformation',
      digitalTransformation: {
        name: 'Digital Transformation',
        description: 'Modernize your business processes with tailored digital strategies'
      },
      consulting: {
        name: 'IT Consulting',
        description: 'Strategic expertise to optimize your technology infrastructure'
      },
      integration: {
        name: 'Systems Integration',
        description: 'Seamless integration solutions for your enterprise systems'
      },
      development: {
        name: 'Web & Desktop Development',
        description: 'High-performance web and desktop applications tailored to your needs'
      },
      devops: {
        name: 'DevOps',
        description: 'Automation and optimization of your deployment pipelines'
      },
      networking: {
        name: 'Networking & Infrastructure',
        description: 'Robust and secure network architecture for your business'
      }
    },
    projects: {
      title: 'Our products',
      subtitle: 'The software built by Prenim and our work across Africa',
      viewDetails: 'View Details'
    },
    testimonials: {
      title: 'What Our Clients Say',
      subtitle: 'The trust of our partners'
    },
    careers: {
      title: 'Join Our Team',
      subtitle: 'Build your career with us',
      apply: 'Apply Now'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Let\'s discuss your project',
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      send: 'Send',
      uk: 'UK Office',
      chad: 'N\'Djamena Office'
    },
    footer: {
      company: 'Company',
      services: 'Services',
      contact: 'Contact',
      rights: 'All rights reserved'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      about: 'عن الشركة',
      projects: 'منتجاتنا',
      careers: 'الوظائف',
      contact: 'اتصل بنا'
    },
    hero: {
      title: 'حول عملك مع',
      subtitle: 'التميز الرقمي',
      description: 'حلول مبتكرة في التحول الرقمي وتطوير التطبيقات والبنية التحتية لتكنولوجيا المعلومات للشركات الأفريقية والأوروبية',
      cta: 'اكتشف خدماتنا',
      ctaSecondary: 'اتصل بنا'
    },
    services: {
      title: 'خدماتنا',
      subtitle: 'حلول شاملة للتحول الرقمي الخاص بك',
      digitalTransformation: {
        name: 'التحول الرقمي',
        description: 'تحديث عمليات عملك باستراتيجيات رقمية مخصصة'
      },
      consulting: {
        name: 'الاستشارات التقنية',
        description: 'خبرة استراتيجية لتحسين البنية التحتية التكنولوجية الخاصة بك'
      },
      integration: {
        name: 'تكامل الأنظمة',
        description: 'حلول تكامل سلسة لأنظمة المؤسسات الخاصة بك'
      },
      development: {
        name: 'تطوير الويب والتطبيقات',
        description: 'تطبيقات ويب وسطح مكتب عالية الأداء مصممة خصيصًا لاحتياجاتك'
      },
      devops: {
        name: 'ديف أوبس',
        description: 'أتمتة وتحسين خطوط النشر الخاصة بك'
      },
      networking: {
        name: 'الشبكات والبنية التحتية',
        description: 'بنية شبكة قوية وآمنة لعملك'
      }
    },
    projects: {
      title: 'منتجاتنا',
      subtitle: 'البرمجيات التي صممتها Prenim وإنجازاتنا عبر أفريقيا',
      viewDetails: 'عرض التفاصيل'
    },
    testimonials: {
      title: 'ماذا يقول عملاؤنا',
      subtitle: 'ثقة شركائنا'
    },
    careers: {
      title: 'انضم إلى فريقنا',
      subtitle: 'ابنِ مسيرتك المهنية معنا',
      apply: 'قدم الآن'
    },
    contact: {
      title: 'اتصل بنا',
      subtitle: 'دعنا نناقش مشروعك',
      first_name: 'الاسم الأول',
      last_name: 'اسم العائلة',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      message: 'الرسالة',
      send: 'إرسال',
      uk: 'مكتب المملكة المتحدة',
      chad: 'مكتب نجامينا'
    },
    footer: {
      company: 'الشركة',
      services: 'الخدمات',
      contact: 'اتصل بنا',
      rights: 'جميع الحقوق محفوظة'
    }
  }
};

export const mockProjects = [
  {
    id: 106,
    title: { fr: 'CAMEDAF — Formation continue en santé', en: 'CAMEDAF — Healthcare Continuing Education', ar: 'كاميداف — التعليم الصحي المستمر' },
    fullName: { fr: 'Campus Médical Africain', en: 'African Medical Campus', ar: 'الحرم الطبي الأفريقي' },
    country: 'Afrique subsaharienne',
    year: 2026,
    category: 'Development',
    description: {
      fr: "Plateforme de formation continue pour le personnel de santé, pensée d'abord pour le mobile. Les hôpitaux, cliniques et centres de santé souscrivent une licence institutionnelle donnant accès aux parcours de formation à l'ensemble de leurs équipes. Conçue pour les contraintes réelles du terrain : réseau intermittent et matériel modeste.",
      en: 'Continuing-education platform for healthcare staff, designed mobile-first. Hospitals, clinics and health centres take out an institutional licence giving their whole staff access to training paths. Built for real conditions on the ground: intermittent connectivity and modest hardware.',
      ar: 'منصة للتعليم المستمر للعاملين في مجال الصحة، مصممة للهواتف المحمولة أولاً. تشترك المستشفيات والعيادات والمراكز الصحية في ترخيص مؤسسي يتيح لجميع موظفيها الوصول إلى مسارات التدريب.'
    },
    technologies: ['LMS', 'Mobile-first', 'Cloud', 'Licences institutionnelles'],
    impact: { fr: 'Personnel hospitalier', en: 'Hospital staff', ar: 'العاملون في المستشفيات' }
  },
  {
    id: 101,
    title: { fr: 'FaDel — Super-app de livraison CEMAC', en: 'FaDel — CEMAC Delivery Super-App', ar: 'فاديل — تطبيق التوصيل الشامل لمنطقة CEMAC' },
    fullName: { fr: 'Fast Delivery', en: 'Fast Delivery', ar: 'التوصيل السريع' },
    country: 'Tchad',
    year: 2026,
    category: 'Development',
    description: {
      fr: 'Super-application de livraison multi-services pour la zone CEMAC, avec N\'Djamena comme ville pilote. Commande en ligne pour les clients, espace de gestion pour les restaurateurs, application mobile pour les livreurs et portail d\'administration, servis par une infrastructure auto-hébergée.',
      en: 'Multi-service delivery super-app for the CEMAC area, piloted in N\'Djamena. Online ordering for customers, a management area for restaurants, a mobile app for couriers and an administration portal, all served by self-hosted infrastructure.',
      ar: 'تطبيق شامل للتوصيل متعدد الخدمات لمنطقة CEMAC، مع نجامينا كمدينة رائدة. طلب عبر الإنترنت للعملاء، ومساحة إدارة للمطاعم، وتطبيق محمول لعمال التوصيل، وبوابة إدارية.'
    },
    technologies: ['Next.js', 'NestJS', 'PostgreSQL', 'Flutter', 'Docker', 'Redis'],
    impact: { fr: 'En production', en: 'In production', ar: 'قيد التشغيل' }
  },
  {
    id: 102,
    title: { fr: 'ConnectBiz — Marketplace B2B CEMAC', en: 'ConnectBiz — CEMAC B2B Marketplace', ar: 'كونكت بيز — سوق B2B لمنطقة CEMAC' },
    fullName: { fr: 'Connect Businesses', en: 'Connect Businesses', ar: 'ربط الشركات' },
    country: 'Zone CEMAC',
    year: 2026,
    category: 'Digital Transformation',
    description: {
      fr: 'Place de marché interentreprises couvrant les six États de la CEMAC. Elle met en relation grossistes, distributeurs et importateurs à l\'échelle régionale, en s\'appuyant sur la monnaie unique XAF et le cadre juridique OHADA, qui suppriment le risque de change et harmonisent les transactions transfrontalières.',
      en: 'Business-to-business marketplace covering the six CEMAC states. It connects wholesalers, distributors and importers across the region, building on the single XAF currency and the OHADA legal framework, which remove exchange-rate risk and harmonise cross-border transactions.',
      ar: 'سوق للتجارة بين الشركات يغطي دول CEMAC الست. يربط تجار الجملة والموزعين والمستوردين على المستوى الإقليمي، بالاعتماد على العملة الموحدة XAF وإطار OHADA القانوني.'
    },
    technologies: ['Microservices', 'React', 'Node.js', 'PostgreSQL', 'Paiement mobile'],
    impact: { fr: '6 pays CEMAC', en: '6 CEMAC countries', ar: '6 دول CEMAC' }
  },
  {
    id: 103,
    title: { fr: 'ComptiaPro — Comptabilité OHADA', en: 'ComptiaPro — OHADA Accounting', ar: 'كومبتيا برو — محاسبة OHADA' },
    country: 'Zone CEMAC',
    year: 2026,
    category: 'Development',
    description: {
      fr: 'Logiciel de comptabilité conforme au référentiel SYSCOHADA, destiné aux PME de la zone CEMAC. Conçu pour fonctionner sans connexion permanente, il répond au vide laissé par les solutions européennes, inadaptées aux normes OHADA et hors de portée financière des entreprises locales.',
      en: 'Accounting software compliant with the SYSCOHADA framework, aimed at small and medium businesses across CEMAC. Built to work without a permanent connection, it fills the gap left by European products that neither support OHADA standards nor match local budgets.',
      ar: 'برنامج محاسبة متوافق مع معايير SYSCOHADA، موجه للشركات الصغيرة والمتوسطة في منطقة CEMAC. مصمم للعمل دون اتصال دائم بالإنترنت.'
    },
    technologies: ['Electron', 'React', 'Node.js', 'SQLite', 'SYSCOHADA'],
    impact: { fr: 'Fonctionne hors ligne', en: 'Works offline', ar: 'يعمل دون اتصال' }
  },
  {
    id: 104,
    title: { fr: 'Kora Housing — Plateforme immobilière', en: 'Kora Housing — Property Platform', ar: 'كورا هاوسينغ — منصة عقارية' },
    country: 'Zone CEMAC',
    year: 2026,
    category: 'Development',
    description: {
      fr: 'Plateforme web de l\'agence immobilière haut standing du groupe, opérant dans les six pays de la CEMAC. Elle couvre la publication et la recherche de biens, la gestion locative, les transactions de vente et l\'administration interne, chaque pays disposant de son propre espace de données isolé.',
      en: 'Web platform for the group\'s upmarket estate agency, operating across the six CEMAC countries. It covers listing and searching properties, rental management, sales transactions and internal administration, with each country holding its own isolated data space.',
      ar: 'منصة إلكترونية لوكالة عقارية راقية تابعة للمجموعة، تعمل في دول CEMAC الست. تغطي نشر العقارات والبحث عنها وإدارة الإيجارات ومعاملات البيع.'
    },
    technologies: ['React', 'Node.js', 'PostgreSQL', 'Cloisonnement par pays'],
    impact: { fr: '6 pays CEMAC', en: '6 CEMAC countries', ar: '6 دول CEMAC' }
  },
  {
    id: 105,
    title: { fr: 'FinSight — Décisionnel bancaire', en: 'FinSight — Banking Intelligence', ar: 'فين سايت — ذكاء الأعمال المصرفي' },
    fullName: { fr: 'Financial Insights', en: 'Financial Insights', ar: 'رؤى مالية' },
    country: 'Tchad',
    year: 2026,
    category: 'Systems Integration',
    description: {
      fr: 'Application décisionnelle qui transforme les données du système bancaire central en récit visuel. Un directeur d\'agence sélectionne un client et déroule sa vie financière sous forme de chronologie animée. L\'ensemble fonctionne en isolement réseau complet, contrainte imposée par la sensibilité des données traitées.',
      en: 'Business-intelligence application that turns core banking data into a visual narrative. A branch manager selects a client and plays back their financial history as an animated timeline. The whole system runs fully air-gapped, a constraint imposed by the sensitivity of the data it handles.',
      ar: 'تطبيق ذكاء أعمال يحوّل بيانات النظام المصرفي الأساسي إلى سرد بصري. يعمل النظام بمعزل تام عن الشبكة نظراً لحساسية البيانات.'
    },
    technologies: ['Business Intelligence', 'Déploiement air-gap', 'Architecture en couches'],
    impact: { fr: 'Isolement réseau total', en: 'Fully air-gapped', ar: 'عزل شبكي تام' }
  },
  {
    id: 1,
    title: { fr: 'Système Bancaire National - Kenya', en: 'National Banking System - Kenya', ar: 'نظام البنوك الوطني - كينيا' },
    country: 'Kenya',
    year: 2023,
    category: 'Digital Transformation',
    description: {
      fr: 'Modernisation complète de l\'infrastructure bancaire avec intégration de services mobiles pour 5 millions d\'utilisateurs. Déploiement d\'une solution cloud-native avec haute disponibilité et conformité réglementaire.',
      en: 'Complete modernization of banking infrastructure with mobile services integration for 5 million users. Deployment of cloud-native solution with high availability and regulatory compliance.',
      ar: 'تحديث شامل للبنية التحتية المصرفية مع دمج الخدمات المحمولة لـ 5 ملايين مستخدم. نشر حل سحابي أصلي مع توفر عالٍ والامتثال التنظيمي.'
    },
    technologies: ['Cloud Architecture', 'Mobile Banking', 'Microservices', 'DevOps'],
    impact: { fr: '5M utilisateurs', en: '5M users', ar: '5 مليون مستخدم' }
  },
  {
    id: 2,
    title: { fr: 'Plateforme E-Gouvernement - Sénégal', en: 'E-Government Platform - Senegal', ar: 'منصة الحكومة الإلكترونية - السنغال' },
    country: 'Senegal',
    year: 2022,
    category: 'Systems Integration',
    description: {
      fr: 'Développement d\'une plateforme nationale unifiant 25 services gouvernementaux. Intégration de systèmes legacy avec architecture moderne, authentification unique et tableau de bord citoyen.',
      en: 'Development of national platform unifying 25 government services. Integration of legacy systems with modern architecture, single sign-on and citizen dashboard.',
      ar: 'تطوير منصة وطنية توحد 25 خدمة حكومية. دمج الأنظمة القديمة مع بنية حديثة ، وتسجيل دخول واحد ولوحة معلومات المواطن.'
    },
    technologies: ['API Gateway', 'SSO', 'Legacy Integration', 'React', 'FastAPI'],
    impact: { fr: '25 services', en: '25 services', ar: '25 خدمة' }
  },
  {
    id: 3,
    title: { fr: 'Réseau Télécoms - RCA', en: 'Telecom Network - CAR', ar: 'شبكة الاتصالات - كار' },
    country: 'RCA',
    year: 2023,
    category: 'Networking',
    description: {
      fr: 'Conception et déploiement d\'une infrastructure réseau fibre optique couvrant 12 villes. Architecture SD-WAN avec redondance, monitoring temps réel et sécurité avancée.',
      en: 'Design and deployment of fiber optic network infrastructure covering 12 cities. SD-WAN architecture with redundancy, real-time monitoring and advanced security.',
      ar: 'تصميم ونشر البنية التحتية لشبكة الألياف الضوئية التي تغطي 12 مدينة. بنية SD-WAN مع التكرار والمراقبة في الوقت الفعلي والأمان المتقدم.'
    },
    technologies: ['SD-WAN', 'Fiber Optics', 'Network Security', 'Monitoring'],
    impact: { fr: '12 villes connectées', en: '12 cities connected', ar: '12 مدينة متصلة' }
  },
  {
    id: 4,
    title: { fr: 'ERP Hospitalier - Nigeria', en: 'Hospital ERP System - Nigeria', ar: 'نظام تخطيط موارد المستشفى - نيجيريا' },
    country: 'Nigeria',
    year: 2021,
    category: 'Development',
    description: {
      fr: 'Système de gestion hospitalière complet pour réseau de 5 hôpitaux. Gestion patients, stock pharmaceutique, RH, facturation avec interopérabilité HL7 et analyses prédictives IA.',
      en: 'Comprehensive hospital management system for network of 5 hospitals. Patient management, pharmaceutical inventory, HR, billing with HL7 interoperability and AI predictive analytics.',
      ar: 'نظام إدارة المستشفيات الشامل لشبكة من 5 مستشفى. إدارة المرضى ، والمخزون الصيدلاني ، والموارد البشرية ، والفواتير مع قابلية التشغيل البيني HL7 والتحليلات التنبؤية بالذكاء الاصطناعي.'
    },
    technologies: ['Desktop Apps', 'HL7', 'AI/ML', 'PostgreSQL', 'Python'],
    impact: { fr: '5 hôpitaux', en: '5 hospitals', ar: '5 مستشفى' }
  },
  {
    id: 5,
    title: { fr: 'Pipeline CI/CD Entreprise - Ghana', en: 'Enterprise CI/CD Pipeline - Ghana', ar: 'خط إنتاج CI/CD للمؤسسة - غانا' },
    country: 'Ghana',
    year: 2022,
    category: 'DevOps',
    description: {
      fr: 'Implémentation d\'une infrastructure DevOps complète pour groupe bancaire. Kubernetes multi-cluster, GitOps, tests automatisés, déploiement continu avec réduction de 80% du temps de mise en production.',
      en: 'Implementation of complete DevOps infrastructure for banking group. Multi-cluster Kubernetes, GitOps, automated testing, continuous deployment with 80% reduction in production deployment time.',
      ar: 'تنفيذ البنية التحتية الكاملة لـ DevOps للمجموعة المصرفية. Kubernetes متعدد العناقيد ، GitOps ، الاختبار الآلي ، النشر المستمر مع تقليل 80٪ في وقت النشر الإنتاجي.'
    },
    technologies: ['Kubernetes', 'GitOps', 'Jenkins', 'Docker', 'Terraform'],
    impact: { fr: '-80% délai déploiement', en: '-80% deployment time', ar: '-80٪ وقت النشر' }
  },
  {
    id: 6,
    title: { fr: 'Transformation Cloud - Côte d\'Ivoire', en: 'Cloud Transformation - Ivory Coast', ar: 'التحول السحابي - ساحل العاج' },
    country: 'Ivory Coast',
    year: 2023,
    category: 'Consulting',
    description: {
      fr: 'Migration complète vers le cloud d\'une compagnie d\'assurance. Architecture multi-cloud AWS/Azure, migration de 200+ applications, formation équipes et optimisation coûts de 40%.',
      en: 'Complete cloud migration of insurance company. AWS/Azure multi-cloud architecture, migration of 200+ applications, team training and 40% cost optimization.',
      ar: 'الترحيل السحابي الكامل لشركة التأمين. بنية سحابية متعددة AWS/Azure ، ترحيل أكثر من 200 تطبيق ، وتدريب الفريق وتحسين التكلفة بنسبة 40٪.'
    },
    technologies: ['AWS', 'Azure', 'Cloud Migration', 'Cost Optimization'],
    impact: { fr: '-40% coûts IT', en: '-40% IT costs', ar: '-40٪ تكاليف تكنولوجيا المعلومات' }
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: 'Dr. Amina Okonkwo',
    position: { fr: 'CTO, FirstBank Kenya', en: 'CTO, FirstBank Kenya', ar: 'مدير التكنولوجيا ، FirstBank Kenya' },
    content: {
      fr: 'Prenim Tchad a transformé notre infrastructure bancaire en seulement 8 mois. Leur expertise en cloud et microservices a permis à nos 5 millions de clients de bénéficier d\'une expérience mobile exceptionnelle.',
      en: 'Prenim Tchad transformed our banking infrastructure in just 8 months. Their cloud and microservices expertise enabled our 5 million customers to benefit from an exceptional mobile experience.',
      ar: 'حولت Prenim Tchad بنيتنا التحتية المصرفية في 8 أشهر فقط. مكنت خبرتهم السحابية والخدمات الدقيقة عملاءنا البالغ عددهم 5 ملايين من الاستفادة من تجربة محمولة استثنائية.'
    },
    rating: 5
  },
  {
    id: 2,
    name: 'Mamadou Diallo',
    position: { fr: 'Ministre Délégué au Numérique, Sénégal', en: 'Deputy Minister for Digital Affairs, Senegal', ar: 'وزير مفوض للشؤون الرقمية ، السنغال' },
    content: {
      fr: 'La plateforme e-gouvernement développée par Prenim Tchad a révolutionné l\'accès aux services publics. 25 services unifiés avec une satisfaction citoyenne de 92%. Un partenaire de confiance.',
      en: 'The e-government platform developed by Prenim Tchad has revolutionized access to public services. 25 unified services with 92% citizen satisfaction. A trusted partner.',
      ar: 'أحدثت منصة الحكومة الإلكترونية التي طورتها Prenim Tchad ثورة في الوصول إلى الخدمات العامة. 25 خدمة موحدة مع رضا المواطنين بنسبة 92٪. شريك موثوق.'
    },
    rating: 5
  },
  {
    id: 3,
    name: 'David Mensah',
    position: { fr: 'VP Engineering, GhanaBank Group', en: 'VP Engineering, GhanaBank Group', ar: 'نائب الرئيس للهندسة ، مجموعة GhanaBank' },
    content: {
      fr: 'L\'implémentation DevOps de Prenim Tchad a réduit nos délais de déploiement de 80%. Leur maîtrise de Kubernetes et GitOps nous a propulsés vers l\'excellence opérationnelle.',
      en: 'Prenim Tchad\'s DevOps implementation reduced our deployment times by 80%. Their mastery of Kubernetes and GitOps propelled us towards operational excellence.',
      ar: 'أدى تطبيق DevOps من Prenim Tchad إلى تقليل أوقات النشر لدينا بنسبة 80٪. أدت إتقانهم لـ Kubernetes و GitOps إلى دفعنا نحو التميز التشغيلي.'
    },
    rating: 5
  }
];

export const mockCareers = [
  {
    id: 1,
    title: { fr: 'Ingénieur DevOps Senior', en: 'Senior DevOps Engineer', ar: 'مهندس DevOps أول' },
    location: { fr: 'Leeds, UK / N\'Djamena', en: 'Leeds, UK / N\'Djamena', ar: 'ليدز، المملكة المتحدة / نجامينا' },
    type: { fr: 'CDI', en: 'Full-time', ar: 'دوام كامل' },
    description: {
      fr: 'Nous recherchons un ingénieur DevOps expérimenté pour concevoir et maintenir nos pipelines CI/CD. Expertise Kubernetes, Terraform et AWS requise.',
      en: 'We are looking for an experienced DevOps engineer to design and maintain our CI/CD pipelines. Kubernetes, Terraform and AWS expertise required.',
      ar: 'نحن نبحث عن مهندس DevOps ذو خبرة لتصميم وصيانة خطوط إنتاج CI/CD الخاصة بنا. مطلوب خبرة Kubernetes و Terraform و AWS.'
    }
  },
  {
    id: 2,
    title: { fr: 'Développeur Full Stack', en: 'Full Stack Developer', ar: 'مطور متكامل' },
    location: { fr: 'N\'Djamena', en: 'N\'Djamena', ar: 'نجامينا' },
    type: { fr: 'CDI', en: 'Full-time', ar: 'دوام كامل' },
    description: {
      fr: 'Rejoignez notre équipe pour développer des applications web modernes. React, FastAPI, et MongoDB. Expérience avec projets africains appréciée.',
      en: 'Join our team to develop modern web applications. React, FastAPI, and MongoDB. Experience with African projects appreciated.',
      ar: 'انضم إلى فريقنا لتطوير تطبيقات الويب الحديثة. React و FastAPI و MongoDB. الخبرة في المشاريع الأفريقية موضع تقدير.'
    }
  },
  {
    id: 3,
    title: { fr: 'Architecte Cloud', en: 'Cloud Architect', ar: 'مهندس معماري سحابي' },
    location: { fr: 'Leeds, UK', en: 'Leeds, UK', ar: 'ليدز، المملكة المتحدة' },
    type: { fr: 'CDI', en: 'Full-time', ar: 'دوام كامل' },
    description: {
      fr: 'Concevez des architectures cloud multi-régions pour nos clients africains et européens. Certifications AWS/Azure Solutions Architect requises.',
      en: 'Design multi-region cloud architectures for our African and European clients. AWS/Azure Solutions Architect certifications required.',
      ar: 'صمم بنى سحابية متعددة المناطق لعملائنا الأفارقة والأوروبيين. مطلوب شهادات AWS/Azure Solutions Architect.'
    }
  },
  {
    id: 4,
    title: { fr: 'Consultant Transformation Digitale', en: 'Digital Transformation Consultant', ar: 'مستشار التحول الرقمي' },
    location: { fr: 'Leeds, UK / N\'Djamena', en: 'Leeds, UK / N\'Djamena', ar: 'ليدز، المملكة المتحدة / نجامينا' },
    type: { fr: 'CDI', en: 'Full-time', ar: 'دوام كامل' },
    description: {
      fr: 'Accompagnez nos clients dans leur transformation digitale. Expertise en stratégie IT, gestion du changement et conduite de projets complexes.',
      en: 'Support our clients in their digital transformation. Expertise in IT strategy, change management and complex project management.',
      ar: 'دعم عملائنا في تحولهم الرقمي. الخبرة في استراتيجية تكنولوجيا المعلومات وإدارة التغيير وإدارة المشاريع المعقدة.'
    }
  },
  {
    id: 5,
    title: { fr: 'Stagiaire Développeur Full Stack (x4)', en: 'Full Stack Developer Intern (x4)', ar: 'متدرب مطور متكامل (×4)' },
    location: { fr: 'N\'Djamena', en: 'N\'Djamena', ar: 'نجامينا' },
    type: { fr: 'Stage', en: 'Internship', ar: 'تدريب' },
    description: {
      fr: 'Nous recrutons 4 stagiaires développeurs Full Stack pour rejoindre nos équipes projet. Vous participerez au développement d\'applications web modernes (React, FastAPI, MongoDB) sous la supervision de développeurs seniors. Une excellente opportunité pour acquérir une expérience concrète sur des projets africains à fort impact.',
      en: 'We are recruiting 4 Full Stack Developer interns to join our project teams. You will participate in the development of modern web applications (React, FastAPI, MongoDB) under the supervision of senior developers. An excellent opportunity to gain hands-on experience on high-impact African projects.',
      ar: 'نقوم بتوظيف 4 متدربين مطورين متكاملين للانضمام إلى فرق المشاريع لدينا. ستشارك في تطوير تطبيقات الويب الحديثة (React و FastAPI و MongoDB) تحت إشراف المطورين المتقدمين. فرصة ممتازة لاكتساب خبرة عملية في مشاريع أفريقية ذات تأثير كبير.'
    }
  },
  {
    id: 6,
    title: { fr: 'Technico-Commercial (x2) — Véhiculé', en: 'Technical Sales Representative (x2) — Own Transport Required', ar: 'مندوب مبيعات تقني (×2) — يمتلك وسيلة نقل' },
    location: { fr: 'N\'Djamena', en: 'N\'Djamena', ar: 'نجامينا' },
    type: { fr: 'CDI', en: 'Full-time', ar: 'دوام كامل' },
    description: {
      fr: 'Nous recherchons 2 technico-commerciaux pour développer notre portefeuille clients à N\'Djamena et en région. Vous assurerez la prospection, la présentation de nos solutions IT et le suivi des clients. Le candidat doit posséder son propre moyen de transport (véhicule ou moto) indispensable pour les déplacements terrain.',
      en: 'We are looking for 2 technical sales representatives to grow our client portfolio in N\'Djamena and surrounding regions. You will handle prospecting, presenting our IT solutions and client follow-up. Candidates must own their own means of transport (car or motorbike) essential for field visits.',
      ar: 'نبحث عن 2 مندوب مبيعات تقني لتنمية محفظة عملائنا في نجامينا والمناطق المحيطة. ستتولى التنقيب وتقديم حلولنا التقنية ومتابعة العملاء. يجب على المرشح امتلاك وسيلة نقل خاصة (سيارة أو دراجة نارية) ضرورية للزيارات الميدانية.'
    }
  }
];
